import { createFileRoute } from '@tanstack/react-router'
import { Board } from './-components/shared/board'
import { BoardPending } from './-components/shared/board-pending'
import { useTeam } from '@/hooks/use-team'
import { reportSearchDeps, prefetchReport } from '@/hooks/use-report'
import { TeamsEmptyState } from './-components/teams/teams-empty-state'
import { ReportError } from './-components/shared/report-error'
import { EmptyState } from './-components/shared/empty-state'

export const Route = createFileRoute('/_app/teams/$teamId/board')({
  loaderDeps: ({ search }) => reportSearchDeps(search),
  loader: ({ context, deps, params }) => {
    prefetchReport(context.queryClient, deps, params)
  },
  component: RouteComponent,
  pendingComponent: BoardPending,
  // Shown immediately: at the router's default pendingMs the NAV STACK cannot push while the loaders run,
  // because the level it would push is the route being rendered — see the full story in jobs.$jobId.report.
  pendingMs: 0,
  pendingMinMs: 0,
})

function RouteComponent() {
  const { teamId } = Route.useParams()
  const { team } = useTeam()

  // `visibleMembers` is already restricted to the selected self-assessments for `ownsManual` (server-side).
  const boardProfiles = (team?.visibleMembers ?? []).map((profile) => ({ ...profile, id: profile.id.toString() }))

  if (team?.error === 'teams-see-owns') {
    return <ReportError error="noPermissionsSeeOwns" surface="board" />
  }

  if (team?.emptyStateCode) {
    return <EmptyState code={team.emptyStateCode} surface="board" />
  }
  // Residual `profile-blocked` with members present (not a count-empty state).
  if (team?.error) {
    return <TeamsEmptyState type="no-members" teamId={teamId} />
  }

  return <Board name={team?.name ?? ''} profiles={boardProfiles} standardIndicators={team?.indicators} />
}
